import React, { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  const path = location.pathname;

  const hideFooter = path === "/privacy";

  return (
    <>
      {!hideFooter ? (
        <>
          <div className="devider150"></div>
          <div style={{ textAlign: "center" }}>
            <a
              className="smallLink"
              style={{ color: "#FFF", letterSpacing: 1, opacity: 1 }}
              href="/privacy"
              target="_blank"
            >
              Integritetspolicy (öppnas i nytt fönster)
            </a>
          </div>
          <footer className="app-footer">
            För supportärenden, kontakta{" "}
            <a href="mailto:jenni@kundupplevelse.com">
              jenni@kundupplevelse.com
            </a>
          </footer>
        </>
      ) : null}
    </>
  );
};

export default Footer;
